<p-card>
    <span class="settings-heading">Users</span>
    <div *ngIf="showSelectEmployeeStep">
        <div class="row-layout-track">
            <div class="flex flex-row justify-content-start gap-4 align-items-center">
                <p-iconfield>
                    <p-inputicon styleClass="pi pi-search"></p-inputicon>
                    <input
                        type="text"
                        pInputText
                        placeholder="Search"
                        [(ngModel)]="employeeSearchTerm"
                        (ngModelChange)="filterEmployees()"
                    />
                </p-iconfield>

                <div class="flex flex-row justify-content-between gap-2 w-auto align-items-center">
                    <label class="text-sm font-semibold">User Status:</label>
                    <p-select
                        [(ngModel)]="activeUserFilter"
                        [options]="activeUserFilterOptions"
                        (onChange)="filterEmployees()"
                    ></p-select>
                </div>

                <span
                    (click)="exportToExcel(kendoGrid)"
                    title="Download Excel"
                    class="usermanagement-export-button"
                >
                    <mat-icon fontSet="fas" fontIcon="fa-file-excel"></mat-icon>
                </span>
            </div>

            <div class="usermanagement-sendemail-button-area">
                <button
                    mat-raised-button
                    class="button"
                    outlined
                    (click)="openChangeClientDialog()"
                    [disabled]="!readyToEmail"
                >
                    <span>Send Email</span><span *ngIf="multipleEmails">s</span> &nbsp;
                    <i class="fa fa-envelope"></i>
                </button>
            </div>
        </div>

        <kendo-grid
            #kendoGrid="kendoGrid"
            [data]="employeeGridView"
            [selectable]="true"
            [kendoGridSelectBy]="'employeeIdentifier'"
            (selectionChange)="employeeSelectionChangeHandler($event)"
            [pageSize]="pageSize"
            [skip]="skip"
            [loading]="loadingEmployees"
            [sortable]="{
                mode: 'single',
                allowUnsort: true
            }"
            class="lg-kendo-grid"
            [sort]="employeeSort"
            (sortChange)="employeeSortChange($event)"
            [pageable]="{
                info: info,
                type: type,
                pageSizes: true,
                previousNext: previousNext
            }"
            [scrollable]="'scrollable'"
            (pageChange)="employeePageChange($event)"
            (dataStateChange)="onStateChange($event)"
            [filter]="state.filter"
        >
            <ng-template kendoGridNoRecordsTemplate>
                <div class="no-data-message-area" *ngIf="noEmployees">
                    <no-data-screen [noDataType]="noDataType"> </no-data-screen>
                </div>
            </ng-template>
            <kendo-grid-column field="primaryIdentifier" title="Employee Number" [width]="20">
            </kendo-grid-column>
            <kendo-grid-column field="lastName" title="Last Name" [width]="20"> </kendo-grid-column>
            <kendo-grid-column field="firstName" title="First Name" [width]="20">
            </kendo-grid-column>
            <kendo-grid-column field="jobTitle" title="Job Title" [width]="30"> </kendo-grid-column>
            <kendo-grid-column field="isUser" title="Is Active" [width]="20">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.isUser ? 'Yes' : 'No' }}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="isClientAdmin" title="Power User" [width]="20">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.isClientAdmin ? 'Yes' : 'No' }}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="positionName" title="Position" [width]="0">
            </kendo-grid-column>

            <kendo-grid-column field="permissionSetName" title="Permissions" [width]="0">
            </kendo-grid-column>

            <kendo-grid-column field="hierarchyLevel" title="Hierarchy Level" [width]="0">
            </kendo-grid-column>

            <kendo-grid-column field="welcomeEmailStatus" title="Email Status" [width]="20">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.welcomeEmailStatus === 0 ? 'Pending' : '' }}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column
                field="welcomeEmailExpirationDate"
                title="Welcome Email"
                [width]="10"
            >
                <ng-template kendoGridHeaderTemplate let-dataItem>
                    <div class="mat-checkbox grid-checkbox">
                        <input
                            type="checkbox"
                            class="mat-checkbox__native-control"
                            (click)="checkAll()"
                            [checked]="emailAllCheckbox"
                        />
                        <div class="mat-checkbox__background">
                            <svg class="mat-checkbox__checkmark" viewBox="0 0 24 24">
                                <path
                                    class="mat-checkbox__checkmark-path"
                                    fill="none"
                                    d="M1.73,12.91 8.1,19.28 22.79,4.59"
                                />
                            </svg>
                            <div class="mat-checkbox__mixedmark"></div>
                        </div>
                    </div>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div
                        class="text-left"
                        *ngIf="
                            (dataItem.welcomeEmailStatus === 0 && canSeePowerUserValues()) ||
                            dataItem.welcomeEmailStatus === 1 ||
                            dataItem.welcomeEmailStatus === 2
                        "
                    >
                        <div class="mat-checkbox grid-checkbox">
                            <input
                                type="checkbox"
                                class="mat-checkbox__native-control check-box-pointer"
                                [checked]="dataItem.sendEmail"
                                (click)="checkChange(dataItem.primaryIdentifier)"
                            />
                            <div class="mat-checkbox__background">
                                <svg class="mat-checkbox__checkmark" viewBox="0 0 24 24">
                                    <path
                                        class="mat-checkbox__checkmark-path"
                                        fill="none"
                                        d="M1.73,12.91 8.1,19.28 22.79,4.59"
                                    />
                                </svg>
                                <div class="mat-checkbox__mixedmark"></div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-excel [fileName]="exportFileName" [fetchData]="getExcelExportData">
            </kendo-grid-excel>

            <ng-template kendoPagerTemplate>
                <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                <kendo-pager-input></kendo-pager-input>
                <kendo-pager-info></kendo-pager-info>
                <kendo-pager-next-buttons></kendo-pager-next-buttons>

                <kendo-pager-page-sizes [pageSizes]="[10, 25, 50, 100]"></kendo-pager-page-sizes>
            </ng-template>
        </kendo-grid>
    </div>
    <!--Edit Existing User-->
    <div *ngIf="user">
        <table class="user-table">
            <tr>
                <td class="row-label">Name:</td>
                <td>
                    {{ selectedEmployee.value.lfName }}
                </td>
            </tr>
            <tr>
                <td class="row-label">Contact Email:</td>
                <td>
                    {{ user.loginEmail }}
                </td>
            </tr>

            <tr>
                <td class="row-label">Login Email:</td>
                <td>
                    <input
                        [disabled]="!user.hasAlternateLoginEmail"
                        type="text"
                        [(ngModel)]="user.alternateLoginEmail"
                    />

                    <span>
                        <span class="row-label" style="padding-left: 20px; padding-right: 15px"
                            >Override Default:
                        </span>
                        <select
                            [(ngModel)]="user.hasAlternateLoginEmail"
                            (ngModelChange)="hasDefaultEmailChangeEvent($event)"
                            style="width: 75px"
                        >
                            <option [ngValue]="true">Yes</option>
                            <option [ngValue]="false">No</option>
                        </select>
                    </span>
                </td>
            </tr>

            <tr>
                <td></td>
                <td></td>
            </tr>

            <tr>
                <td class="row-label">Job Title:</td>
                <td>
                    {{ selectedEmployee.value.jobTitle }}
                </td>
            </tr>

            <tr>
                <td class="row-label">Position:</td>
                <td>{{ selectedEmployee.value.positionName }}</td>
            </tr>

            <tr>
                <td class="row-label">Location:</td>
                <td>{{ selectedEmployee.value.location }}</td>
            </tr>

            <tr>
                <td></td>
                <td></td>
            </tr>

            <tr>
                <td class="row-label">Permission Set:</td>
                <td>
                    <select
                        [(ngModel)]="user.permissionSetName"
                        [disabled]="user.hasDefaultPermissions"
                        *ngIf="!user.isClientAdmin"
                    >
                        <option
                            *ngFor="let permission of clientPermissionSets"
                            [value]="permission.name"
                        >
                            {{ permission.name }}
                        </option>
                    </select>
                    <span *ngIf="user.isClientAdmin && !user.isClientOwner">Power User</span>
                    <span *ngIf="user.isClientOwner">Admin User</span>
                    &nbsp;
                    <span *ngIf="!user.isClientAdmin">
                        <span class="row-label" style="padding-left: 10px; padding-right: 15px"
                            >Override Default:
                        </span>
                        <select
                            [(ngModel)]="user.hasDefaultPermissions"
                            (ngModelChange)="hasDefaultPermissionsChangeEvent($event)"
                            style="width: 75px"
                        >
                            <option [ngValue]="false">Yes</option>
                            <option [ngValue]="true">No</option>
                        </select>
                    </span>
                </td>
            </tr>

            <tr>
                <td class="row-label">Hierarchy Level:</td>
                <td>
                    <select
                        [(ngModel)]="user.clientCustomRoleName"
                        [disabled]="user.hasDefaultAccess || user.isClientAdmin"
                        *ngIf="!user.isClientAdmin"
                        (ngModelChange)="lowerHierarchyLevelChangeHandler($event)"
                    >
                        <option *ngFor="let role of clientCustomRoles" [value]="role.roleName">
                            {{ role.roleName }}
                        </option>
                    </select>
                    <span *ngIf="user.isClientAdmin">{{ user.clientCustomRoleName }}</span>

                    &nbsp;
                    <span *ngIf="!user.isClientAdmin">
                        <span class="row-label" style="padding-left: 10px; padding-right: 15px"
                            >Override Default:
                        </span>
                        <select
                            [(ngModel)]="user.hasDefaultAccess"
                            (ngModelChange)="hasDefaultAccessChangeEvent($event, true)"
                            style="width: 75px"
                        >
                            <option [ngValue]="false">Yes</option>
                            <option [ngValue]="true">No</option>
                        </select>
                    </span>
                </td>
            </tr>

            <tr *ngIf="canSeeClientOwnerValues()">
                <td class="row-label">General Ledger Access:</td>
                <td>
                    <select
                        [(ngModel)]="user.hasGLAccess"
                        style="width: 75px"
                        (ngModelChange)="glDataSelectChangeHandler($event)"
                    >
                        <option [ngValue]="true">Yes</option>
                        <option [ngValue]="false">No</option>
                    </select>
                </td>
            </tr>

            <tr *ngIf="canExtendAccess() && canSeePowerUserValues()">
                <td class="row-label">Extended Access:</td>
                <td>
                    <button
                        mat-button
                        class="button"
                        outlined
                        (click)="extendedAccessMenuToggle()"
                        [disabled]="user.hasDefaultAccess"
                    >
                        Edit &nbsp;
                        <i class="far fa-edit"></i>
                    </button>
                </td>
            </tr>

            <tr>
                <td></td>
                <td></td>
            </tr>

            <tr>
                <td class="row-label">Enabled:</td>
                <td>
                    <select [(ngModel)]="user.isDisabled" style="width: 75px">
                        <option [ngValue]="true">No</option>
                        <option [ngValue]="false">Yes</option>
                    </select>
                </td>
            </tr>

            <tr *ngIf="canSeeClientOwnerValues()">
                <td class="row-label">Admin User:</td>
                <td>
                    <select
                        [(ngModel)]="user.isClientOwner"
                        style="width: 75px"
                        (ngModelChange)="clientOwnerSelectChangeHandler($event)"
                    >
                        <option [ngValue]="true">Yes</option>
                        <option [ngValue]="false">No</option>
                    </select>
                </td>
            </tr>

            <tr *ngIf="canSeePowerUserValues()">
                <td class="row-label">Power User:</td>
                <td>
                    <select
                        [(ngModel)]="user.isClientAdmin"
                        style="width: 75px"
                        (ngModelChange)="powerUserSelectChangeHandler($event)"
                        [disabled]="user.isClientOwner"
                    >
                        <option [ngValue]="true">Yes</option>
                        <option [ngValue]="false">No</option>
                    </select>
                </td>
            </tr>

            <tr *ngIf="!useSSO">
                <td
                    class="row-label"
                    *ngIf="
                        (selectedEmployee.value.isUser || user) &&
                        selectedEmployee.value.lastLoginDate === null
                    "
                >
                    Welcome Email:
                </td>
                <td
                    class="row-label"
                    *ngIf="
                        (selectedEmployee.value.isUser || user) &&
                        selectedEmployee.value.lastLoginDate !== null
                    "
                >
                    Password
                </td>
                <td
                    *ngIf="
                        selectedEmployee.value.welcomeEmailStatus === 0 &&
                        canSeePowerUserValues() &&
                        (selectedEmployee.value.isUser || user)
                    "
                >
                    Pending
                    <span class="resend-button-wrapper">
                        <button mat-stroked-button outlined (click)="updateSendStatus()">
                            Resend &nbsp;
                            <i class="fa fa-envelope" aria-hidden="true"></i>
                        </button>
                    </span>
                </td>
                <td
                    *ngIf="
                        (selectedEmployee.value.welcomeEmailStatus === 1 ||
                            selectedEmployee.value.welcomeEmailStatus === 2) &&
                        (selectedEmployee.value.isUser || user)
                    "
                >
                    <button mat-stroked-button outlined (click)="updateSendStatus()">
                        Send &nbsp;
                        <i class="fa fa-envelope" aria-hidden="true"></i>
                    </button>
                </td>
                <td
                    *ngIf="
                        selectedEmployee.value.lastLoginDate !== null &&
                        (selectedEmployee.value.isUser || user)
                    "
                >
                    <button mat-stroked-button outlined (click)="resetPassword()">
                        Reset &nbsp;
                        <i class="far fa-redo" aria-hidden="true"></i>
                    </button>
                </td>
            </tr>
        </table>
    </div>
    <!--Create New User-->
    <div *ngIf="employeeIdentifier && !selectedEmployee.value.isUser && !user">
        <table class="user-table">
            <tr>
                <td class="row-label">Name:</td>
                <td>
                    {{ selectedEmployee.value.lfName }}
                </td>
            </tr>
            <tr>
                <td class="row-label">Job Title:</td>
                <td>
                    {{ selectedEmployee.value.jobTitle }}
                </td>
            </tr>
            <tr>
                <td class="row-label">Primary Email:</td>
                <td>
                    {{ selectedEmployee.value.loginEmail }}
                </td>
            </tr>
        </table>
    </div>

    <div>
        <button *ngIf="stepNumber > 1" mat-raised-button type="reset" (click)="goToPreviousStep()">
            BACK
        </button>
        <button
            *ngIf="
                onFinalStep && !selectedEmployee.value.isUser && !user && canSeePowerUserValues()
            "
            type="button"
            mat-raised-button
            (click)="createUser()"
            style="margin-left: 15px"
            [disabled]="!canCreateUser"
        >
            CREATE USER
        </button>
        <button
            *ngIf="onFinalStep && (selectedEmployee.value.isUser || user)"
            type="button"
            mat-raised-button
            [disabled]="saveDisabled()"
            (click)="editExistingUser()"
            style="margin-left: 15px"
        >
            Save
        </button>
    </div>
</p-card>

<app-user-extended-access-menu
    *ngIf="extendAccessMenu && user"
    (cancel)="extendedAccessMenuCanceled($event)"
    (saved)="extendedAccessMenuSaved()"
    [user]="user"
    [employees]="employees"
    [clientShortName]="clientShortName"
>
</app-user-extended-access-menu>
